import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "SuccessInput";
export const classes = {
  rootContract: `${PREFIX}-rootContract`,
  rootSuivi: `${PREFIX}-rootSuivi`,
  cddStack: `${PREFIX}-cddStack`,
};

export const ContractDurationStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.rootContract}`]: {
    flexBasis: "100%",
    flexDirection: "row",
    gap: theme.spacing(3),
  },
  [`& .${classes.cddStack}`]: {
    flexBasis: "100%",
  },
}));

export const SuiviStack = styled(Stack)(() => ({
  [`&.${classes.rootSuivi}`]: {
    flexBasis: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));
